import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AcceptImportToOrganisationRequestMutationVariables = Types.Exact<{
  inviteId: Types.Scalars['ID']['input'];
}>;


export type AcceptImportToOrganisationRequestMutation = { __typename?: 'Mutation', acceptAddToOrganisationRequest: boolean };


export const AcceptImportToOrganisationRequestDocument = gql`
    mutation AcceptImportToOrganisationRequest($inviteId: ID!) {
  acceptAddToOrganisationRequest(requestId: $inviteId)
}
    `;
export type AcceptImportToOrganisationRequestMutationFn = Apollo.MutationFunction<AcceptImportToOrganisationRequestMutation, AcceptImportToOrganisationRequestMutationVariables>;

/**
 * __useAcceptImportToOrganisationRequestMutation__
 *
 * To run a mutation, you first call `useAcceptImportToOrganisationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptImportToOrganisationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptImportToOrganisationRequestMutation, { data, loading, error }] = useAcceptImportToOrganisationRequestMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useAcceptImportToOrganisationRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptImportToOrganisationRequestMutation, AcceptImportToOrganisationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptImportToOrganisationRequestMutation, AcceptImportToOrganisationRequestMutationVariables>(AcceptImportToOrganisationRequestDocument, options);
      }
export type AcceptImportToOrganisationRequestMutationHookResult = ReturnType<typeof useAcceptImportToOrganisationRequestMutation>;
export type AcceptImportToOrganisationRequestMutationResult = Apollo.MutationResult<AcceptImportToOrganisationRequestMutation>;
export type AcceptImportToOrganisationRequestMutationOptions = Apollo.BaseMutationOptions<AcceptImportToOrganisationRequestMutation, AcceptImportToOrganisationRequestMutationVariables>;